<template>
<v-card flat >
  <v-toolbar v-if='withTitle' dense flat dark :extended="$vuetify.breakpoint.xs" >
    <v-toolbar-title >
      <span >{{ clientFullName }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <template v-if="$vuetify.breakpoint.smAndUp" >
      <mailchimp-chip
        v-if='mailchimpIntegration && clientEmail && relationshipId'
        :email='clientEmail'
        :relationship-id='relationshipId' >
      </mailchimp-chip>
      <!-- {{physitrackIntegration}} -->
      <physitrack-embed v-if='physitrackIntegration && relationshipId'
        :relationship-id='relationshipId' >
      </physitrack-embed>
    </template>
    <template v-else slot='extension' >
      <mailchimp-chip
        v-if='mailchimpIntegration && clientEmail && relationshipId'
        :email='clientEmail'
        :relationship-id='relationshipId' >
      </mailchimp-chip>
      <!-- {{physitrackIntegration}} -->
      <physitrack-embed v-if='physitrackIntegration && relationshipId'
        :relationship-id='relationshipId' >
      </physitrack-embed>
    </template>
    <!-- <v-btn @click='reload' icon >
      <v-icon>replay</v-icon>
    </v-btn> -->
    <!-- hasColleagues -->
    <template v-if='client && client.id' >
      <v-btn @click='sharingdialog=true' dark icon small >
        <v-icon small>share</v-icon>
      </v-btn>
      <v-dialog v-model='sharingdialog' width="360" >
        <v-card tile>
          <v-card-title class='py-1 overline' >
            Sharing
            <help-popover >
              Members of spaces with which this client is shared will be able to view and edit the client
              as well as creating appointments and invoices for them. <br/>
              Only the owner is able to change sharing settings
            </help-popover>
            <v-spacer></v-spacer>
            <v-btn @click="sharingdialog=false" small icon ><v-icon small >close</v-icon></v-btn>
          </v-card-title>
          <request-status :request='requests.share' >
          </request-status>
          <v-card-text>

            <sharing-information
              class='ml-3'
              v-if='ownerId'
              :context='client.context'
              :owner-id='ownerId'
              :space-ids='client.spaces' />

            <space-picker required
              v-model='client.spaces'
              :with-select='false'
              label='Contact is shared with these spaces'
              direction='bottom' ></space-picker>

            <v-alert type='info' :value='true' class='py-1 caption lighten-1 mt-3' dismissible >
              <strong>Note:</strong>
              only an owner of these spaces can change the sharing preferences
            </v-alert>
          </v-card-text>
          <v-divider/>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn
              @click='setSharing'
              :loading='this.requests.share.loading'
              color='primary' >
                <span v-if='client.spaces.length === 0' >Clear sharing</span>
                <span v-else >Update sharing</span>
                </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-toolbar>
  <template  v-if='client && client.id' >
    <v-tabs v-if='!isCompact' vertical dark show-arrows grow v-model='activeTab' >
      <v-tab
        v-for="(item, index) in items"
        :key="item.id" >
        <v-icon v-if='index===0' >home</v-icon>
        <span v-else >{{ item.title }}</span>
      </v-tab>
      <v-tabs-items
        v-model='activeTab' >
        <v-tab-item
          v-for="(item, index) in items"
        :key="item.id" >
        <!-- <keep-alive> -->
          <component lazy
            v-if='item.component && activeTab === index'
            :is='item.component'
            v-bind='item.attrs'
            v-on='item.evnts || {}'
            @report='showReport'
            @close='$emit("close")'
            @click:share='sharingdialog = true'
            @goto='gotoTabName' >

            <template slot='toolbar-buttons' >
              <v-btn v-if='item.id === "Statement"' flat small class='hidden-xs-only'
                @click="showReport('account')" >Print report
              </v-btn>
              <v-btn v-if='item.id === "Notes"' flat small class='hidden-xs-only mr-5'
                @click="showReport('client-report')" >Print report
              </v-btn>
            </template>

          </component>
        <!-- </keep-alive> -->
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <v-expansion-panel v-else v-model='activeTab' class='elevation-0' focusable  >
      <v-expansion-panel-content
        v-for="(item, index) in items"
        :key="item.id" >
        <template v-slot:header>
          <div class='subheading' >
            {{item.title}}</div>
        </template>
        <component
          lazy
          v-if='item.component && activeTab === index'
          :is='item.component'
          v-bind='item.attrs'
          v-on='item.evnts || {}'
          @click:share='sharingdialog = true'
          @goto='gotoTabName' >
        </component>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </template>
  <v-footer class='px-3 mt-4' v-if='client && client.client'>
    <small>
    {{ clientFullName }}, Client #{{client.client.id}}. Rel #{{client.id}}
    </small>
    <v-spacer></v-spacer>
    <!-- Tags: {{}} -->
  </v-footer>

  <v-dialog v-model='showReportDialog' width='500'  >
    <report-form
      :relationship-id='relationshipId'
      :report-name='reportName'
      @close='showReportDialog=false' />
  </v-dialog>
</v-card>
</template>

<script>
import PatientInformationForm from '@/components/medicalaid/PatientInformationForm'
import ClientAppointments from '@/components/client/detail/ClientAppointments'
// import ClientContactDetails from '@/components/client/ClientContactDetails'
// import ClientCreate from '@/components/client/Create'
import ClientIndex from '@/components/client/ClientIndex'
import NoteList from '@/components/NoteList'
import ClientInvoices from '@/components/client/ClientInvoices'
import Statement from '@/components/statement'
import ClientCodes from '@/components/client/ClientCodes'
import MailchimpChip from '@/components/pages/Integrations/Mailchimp/MailchimpChip'
import PhysitrackEmbed from '@/components/pages/Integrations/Physitrack/PhysitrackEmbed'
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import HelpPopover from '@/components/ui/HelpPopover'
import SharingInformation from '@/components/ui/SharingInformation.vue'
import ReportForm from '@/components/client/forms/ReportForm.vue'
import {LIST_CLIENTS_REQ} from '@/store/constants'
import moment from 'moment'

export default {
  props: {
    value: { type: Object, default: () => { return {client: {}} } },
    // clientId: { description: 'This is the id of the django user associated with this client. Typically, this is client.client.id' },
    // relationshipId: { description: 'This is the new, proper, way to refer to a client of a practitioner client.id' },
    fetch: { type: Boolean, default: false },
    isCompact: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: true }
  },
  components: {
    ClientAppointments,
    NoteList,
    PatientInformationForm,
    SharingInformation,
    // ClientContactDetails,
    ClientCodes,
    // ClientCreate,
    ClientInvoices,
    Statement,
    SpacePicker,
    MailchimpChip,
    PhysitrackEmbed,
    HelpPopover,
    ReportForm
  },
  data () {
    return {
      reqId: 'get-appointments-request',
      clientReqId: 'get-client-request',
      activeTab: 0,
      client: {},
      clientContactDetailsComponent: 'client-contact-details',
      clientsReqId: LIST_CLIENTS_REQ,
      touchers: {
        home: 1,
        record: 1,
        notes: 1,
        invoices: 1,
        codes: 1
      },
      showReportDialog: false,
      reportName: null,
      sharingdialog: false,
      appointment: null, // active apointment
      // statement
      statementRequestId: 'statement-detail-request',
      selectedAppointments: [],
      statementFilters: {
        from_date: moment().startOf('month').format('YYYY-MM-DD')
      },
      requests: {
        share: {}
      },
      actionItems: [
        'appointment_codes',
        'show_payment'
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.client = this.value
          // console.log('cli:' + this.clientId, 'rel:' + this.relationshipId)
        }
      }
    },
    clientId: {
      immediate: true,
      handler () {
        this.getClient()
        this.getActiveTab()
      }
    },
    shareRequestStatus () {
      if (this.shareRequestStatus === 200) {
        console.log(this.activeTab)
        this.touchers.home++
        this.getClient()
      }
    },
    storeClient () {
      if (this.storeClient && this.storeClient.id) {
        this.client = this.storeClient
      }
    },
    activeTab () {
      this.getActiveTab()
    },
    clientRequestStatus () {
      if (this.clientRequestStatus === 200) {
        this.client = this.clientRequest.result.data
        this.$emit('input', this.clientRequest.result.data)
      }
    },
    paramTab: {
      immediate: true,
      handler () {
        if (this.paramTab) {
          let tab = parseInt(this.paramTab)
          if (isNaN(tab)) {
            this.gotoTabName(this.paramTab)
          } else {
            this.setTab(tab)
          }
        }
      }
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.xsOnly) {
      this.activeTab = null
    }
    if (this.clientId) {
      this.getActiveTab()
    }
  },
  computed: {
    clientId () {
      return this.client.id
    },
    storeClient () {
      if (this.client) {
        return this.getRelationById(this.client.id)
      }
    },
    paramTab () {
      return this.$route.params.tab
    },
    relationshipId () {
      return this.client.id
    },
    userId () {
      return this.getObjectPath(this.client, 'client.id')
    },
    clientFullName () {
      let name = ''
      if (this.client && this.client.client) {
        let cli = this.client.client
        if (cli.first_name) { name = cli.first_name }
        if (cli.last_name) { name = name + ' ' + cli.last_name }
      }
      return name
    },
    accountReport () {
      return this.$appointmentguru.baseUrl + '/' + this.relationshipId + '/reports/'
    },
    clientEmail () {
      if (this.client && this.client.client) { return this.client.client.email }
    },
    clientRequest () {
      return this.$store.getters.getRequestById(this.clientReqId, true)
    },
    clientRequestStatus () {
      return this.clientRequest.status
    },
    clientAppointmentsRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    clientAppointments () {
      return this.getObjectPath(this.clientAppointmentsRequest, 'result.data.results', [])
    },
    me () {
      return this.$store.getters.me
    },
    statementRequest () {
      return this.$store.getters.getRequestById(this.statementRequestId, true)
    },
    statement () {
      return this.getObjectPath(this.statementRequest, 'result.data', {})
    },
    mailchimpIntegration () {
      return this.$store.getters.getIntegration('Mailchimp')
    },
    physitrackIntegration () {
      return this.$store.getters.getIntegration('Physitrack')
    },
    isOwner () {
      return (this.client.practitioner === this.me.id)
    },
    ownerId () {
      return this.getObjectPath(this.client, 'practitioner')
    },
    shareRequestStatus () {
      return this.requests.share.status
    },
    items () {
      let vm = this
      let relationship = this.client
      let clientId = null
      let relationshipId = relationship.id
      if (relationship.client) {
        clientId = relationship.client.id
      }
      return [
        {
          id: 'home',
          title: 'Home',
          component: ClientIndex,
          attrs: {
            relationshipId: relationshipId,
            isCompact: this.isCompact,
            touch: this.touchers.home
          },
          on: () => {
            vm.touchers.home++
          }
        },
        {
          id: 'Record',
          title: this.$t('tabs.clientinfo.title'),
          component: PatientInformationForm,
          attrs: {
            touch: this.touchers.codes,
            relationshipId,
            fetch: true,
            withContactDetails: true,
            practitionerId: this.me.id
          },
          on: () => {
            vm.touchers.record++
          }
        },
        {
          id: 'Notes',
          title: this.$t('tabs.notes.title'),
          component: NoteList,
          attrs: {
            withAdd: true,
            touch: this.touchers.notes,
            emptyText: 'No notes for this client',
            client: relationship,
            relationshipId: relationshipId
          },
          on: () => {
            vm.touchers.notes++
          }
        },
        {
          id: 'Statement',
          title: this.$t('tabs.statement.title'),
          component: Statement,
          attrs: {
            value: this.statement,
            client: relationship,
            initialFilterText: 'Showing all appointments for this month',
            filterFromDate: this.statementFilters.from_date,
            withSelectable: true,
            withReload: true,
            withPreNext: false,
            withFilters: true,
            isCompact: this.isCompact,
            loading: this.statementRequest.loading
          },
          evnts: {
            dateRangeChangeRequested: this.launchDateRangePicker,
            reload: this.getStatement
          },
          on: () => {
            vm.getStatement()
          }
        },
        {
          id: 'Appointments',
          title: this.$t('tabs.appointments.title'),
          component: ClientAppointments,
          attrs: {
            relationship,
            appointments: this.clientAppointments,
            loading: this.clientAppointmentsRequest.loading
          },
          evnts: {
            'refresh': () => {
              vm.getAppointments()
            }
          },
          on: () => {
            vm.getAppointments()
          }
        },
        {
          id: 'Invoices',
          title: this.$t('tabs.invoices.title'),
          component: ClientInvoices,
          attrs: {
            touch: this.touchers.invoices,
            clientId,
            relationshipId
          },
          on: () => {
            this.touchers.invoices++
          }
        },
        {
          id: 'Codes',
          title: this.$t('tabs.codes.title'),
          component: ClientCodes,
          attrs: {
            touch: this.touchers.codes,
            relationshipId,
            clientId
          },
          on: () => {
            this.touchers.codes++
          }
        }
      ]
    }
  },
  methods: {
    reload () {
      this.getClients()
    },
    getActiveTab () {
      if (this.activeTab !== null) {
        let activeComponent = this.items[this.activeTab]
        if (activeComponent) {
          activeComponent.on()
        }
      }
    },
    gotoTabName (tabname) {
      let index = this.items.findIndex((item) => {
        return item.id.toLowerCase() === tabname
      })
      this.setTab(index)
    },
    setTab (index) {
      this.activeTab = index
    },
    // statement:
    getStatement (filters) {
      if (filters) {
        this.statementFilters = filters
      }
      this.$appointmentguru
        .resource('v3.statement')
        .id(this.statementRequestId)
        .get(
          this.client.client.id,
          this.statementFilters
        )
    },
    actionClicked (action, appointment) {
      appointment.client = this.client
      action.onclick(appointment)
    },
    showReport (reportName) {
      this.showReportDialog = true
      this.reportName = reportName
    },
    getClient () {
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(this.clientReqId)
        .get(this.clientId)
    },
    getAppointments () {
      let params = {
        practitioner: this.$store.getters.me.id,
        client: this.client.client.id,
        ordering: '-start_time'
      }
      this.$appointmentguru
        .resource('appointments')
        .id(this.reqId)
        .list(params)
    },
    setSharing () {
      let data = {spaces: this.client.spaces.join(',')}
      this.action(
        this.$appointmentguru,
        'practitioner',
        'relationships',
        this.relationshipId,
        'set_spaces',
        data,
        this.requests.share
      )
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          statement: {
            title: 'Account'
          },
          appointments: {
            title: 'Appointments'
          },
          clientinfo: {
            title: 'Client info'
          },
          notes: {
            title: 'Notes'
          },
          invoices: {
            title: 'Invoices'
          },
          codes: {
            title: 'Codes'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientDetails.vue?d33c1c76